import { faPrint, faMoneyBillWave, faReceipt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, Button, Grid } from '@mui/material'
import { t } from 'i18next'
import { BillItemFragment, BillListItemFragment, useBillsListQuery } from 'src/api/api.generated'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import BillLookup from '../../bill/components/BillLookup'

type PosActionsRowProp = {
  propertyId: string
  loading: boolean
  isPasserbyBill: boolean
  bill: BillListItemFragment | { id: string } | null
  setBill: (bill: BillListItemFragment | null) => void
  finishAndPay: () => void
  accountBalance: () => void
  onPasserbyBill: () => void
}

export default function PosActionsRow(props: PosActionsRowProp) {
  const { propertyId, loading, isPasserbyBill, bill, setBill, finishAndPay, accountBalance, onPasserbyBill } = props

  const { fetchMore } = useBillsListQuery({ skip: true })

  const { sm } = useBreakpoints()

  const getBillAndProduction = async (bill: BillItemFragment | null) => {
    if (bill) {
      const result = await fetchMore({
        variables: {
          filter: {
            tenantId: { eq: bill.tenantId },
            propertyId: { eq: bill.propertyId },
            id: { eq: bill.id },
          },
        },
      })
      if (result.data.bills) {
        setBill(result.data.bills[0])
      }
    } else {
      setBill(null)
    }
  }

  return (
    <>
      <Grid container spacing={1} width={'100%'}>
        <Grid item xs={12} sm={6}>
          <BillLookup
            disabled={loading}
            propertyId={propertyId}
            value={bill}
            onChange={(value) => {
              getBillAndProduction(value ?? null)
            }}
          />
        </Grid>
        {isPasserbyBill && (
          <Grid item xs={12} sm={6}>
            <Stack direction="row" alignItems="center" justifyContent={sm ? 'flex-end' : 'flex-start'} spacing={1} sx={{ height: '100%' }}>
              <Button size="small" variant="outlined" disabled={loading} sx={{ height: '32px' }} onClick={onPasserbyBill}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <FontAwesomeIcon icon={faReceipt} />
                  <p>{t('pms.menu.passerby')}</p>
                </Stack>
              </Button>
              <Button size="small" variant="outlined" disabled={loading} sx={{ height: '32px' }} onClick={accountBalance}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <FontAwesomeIcon icon={faPrint} />
                  <p>{t('pms.booking.pos.account_balance_button')}</p>
                </Stack>
              </Button>
              <Button size="small" variant="contained" disabled={loading} sx={{ height: '32px' }} onClick={finishAndPay}>
                <Stack direction="row" spacing={1} alignItems="center" height={'100%'}>
                  <FontAwesomeIcon icon={faMoneyBillWave} />
                  <p>{t('pms.booking.pos.complete_and_pay_button')}</p>
                </Stack>
              </Button>
            </Stack>
          </Grid>
        )}
      </Grid>
    </>
  )
}
